import {
  USER_LEAVE_FETCHING,
  USER_LEAVE_FAILED,
  USER_LEAVE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case USER_LEAVE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case USER_LEAVE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case USER_LEAVE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
